import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PUBLISH_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SalesPublishPage } from '@/features/publish/pages/SalesPublishPage';
import { batchSearchSchema } from '@/features/publish/types/publish.types';

export const Route = createFileRoute('/_auth/publish/sales')({
  beforeLoad: () => requirePermission(PUBLISH_PERMISSIONS.SALES_VIEW),
  validateSearch: batchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Sales Publish Panel">
      <Suspense fallback={<PageLoader />}>
        <SalesPublishPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
